import { c as _c } from "react/compiler-runtime";
import { twMerge } from 'tailwind-merge';
export default function KlickerPracticeQuizBlock(t0) {
  const $ = _c(6);
  const {
    title,
    klickerCourseId,
    klickerPracticeQuizId,
    locale
  } = t0;
  if (!klickerCourseId || !klickerPracticeQuizId) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="text-sm text-red-700">Klicker block is not configured correctly (missing courseId or practiceQuizId).</div>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = (process.env.NEXT_PUBLIC_KLICKER_PWA_URL ?? "https://pwa.klicker.uzh.ch").replace(/\/+$/, "");
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const baseUrl = t1;
  const localePrefix = locale ? `/${encodeURIComponent(locale)}` : "";
  const quizUrl = `${baseUrl}${localePrefix}` + `/course/${encodeURIComponent(klickerCourseId)}` + `/practiceQuizzes/${encodeURIComponent(klickerPracticeQuizId)}` + "?embed=true";
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = twMerge("w-full relative overflow-hidden rounded-lg", "min-h-[600px] h-[80vh] in-iframe:h-auto in-iframe:aspect-[3/4] in-iframe:max-h-none");
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== quizUrl || $[4] !== title) {
    t3 = <div className="w-full"><div className={t2}><iframe className="absolute inset-0 w-full h-full border-0" src={quizUrl} title={title} loading="lazy" referrerPolicy="strict-origin-when-cross-origin" allow="autoplay *; fullscreen *; encrypted-media *; gyroscope; picture-in-picture; web-share" sandbox="allow-downloads allow-forms allow-same-origin allow-scripts allow-top-navigation allow-pointer-lock allow-popups allow-modals allow-orientation-lock allow-popups-to-escape-sandbox allow-presentation allow-top-navigation-by-user-activation" allowFullScreen={true} /></div></div>;
    $[3] = quizUrl;
    $[4] = title;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}